import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Select, message, Spin } from 'antd'
import { SGeneralForms } from 'shj-components'
import { getRegionLists, getAllCompany, getAllCompanyMrn } from '@/services/customerServices'
const { Option } = Select
export const AddOrEditForm = (props: any) => {
  const { editData } = props
  const formRef: any = useRef()
  const [companyMrnList, setCompanyMrnList] = useState([] as any)
  const [spinning, setSpinning] = useState(false)
  const reqMeg = '不能为空'
  useEffect(() => {
    initFn()
  }, [])

  const initFn = async () => {
    setSpinning(true)
    if (editData) {
      getMrn()
      formRef.current?.onFormRef()?.setFieldsValue({ ...editData })
      setSpinning(false)
    }
  }

  const getOptions = async () => {
    // const companyList = await getAllCompany({})
    // return Promise.resolve({
    //   companyList: companyList,
    // })
  }
  const getMrn = async () => {
    const companyMrn = await getAllCompanyMrn({
      userIdentityFilter: {
        companyId: editData.companyId,
        identityType: "INSIDE",
      },
    })
    setCompanyMrnList(companyMrn)
  }
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        layout={'vertical'}
        httpOptionsFn={getOptions}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '选择门店/分配人',
                name: 'dispatchUserId',
                spanCol: 24,
                type: 'select',
                required: true,
                children: (
                  <Select
                    showSearch
                    placeholder={'请选择分配人'}
                    filterOption={(input, option) =>
                      (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {companyMrnList.map((item: any) => (
                      <Option key={item.ucenterUserId} value={item.ucenterUserId}>
                        {item.userName}
                      </Option>
                    ))}
                  </Select>
                ),
              },
            ],
          },
        ]}
      />
    </Spin>
  )
}
